export default __webpack_public_path__ + "static/media/gestion.495b5b9e.png";